export default "__VITE_ASSET__BkE8qizk__"